export default {
  lang: '',
  profile: {}
}
